import { Actions, ofType, createEffect } from "@ngrx/effects";
import { Injectable, Renderer2 } from '@angular/core';
import { tap, switchMap } from 'rxjs/operators';
import { ENABLE_EXPORT, ExportAction, SAVE_TABLE_EXCEL, STAGE_TABLE } from '../actions';
// import { GapiService } from '../../gapi.service';
import { of } from "rxjs";
import { ReportCacheService } from "core";
import { Router } from "@angular/router";

@Injectable()
export class ExportEffects {

    constructor(
        private actions$: Actions<ExportAction>,
        // private gapi: GapiService,
        private rc: ReportCacheService,
        private router: Router,
        // private renderer: Renderer2
    ) { }

    //  enableExport$ = createEffect(() => this.actions$.pipe(
    //     ofType(ENABLE_EXPORT),
    //     switchMap(() => this.gapi.signedIn$),
    //     tap(signedIn => {
    //         if (!signedIn) {
    //             this.gapi.signIn();
    //         }
    //     })
    // ), { dispatch: false });

    // exportTables$ = createEffect(() => th)

    exportTable$ = createEffect(() => this.actions$.pipe(
        ofType(SAVE_TABLE_EXCEL),
        switchMap(({ payload: { tableId } }) => {
            const cacheKey: string = this.router.routerState.snapshot.root.firstChild.params.cacheKey;
            // console.log(this.router.routerState.snapshot.root.firstChild);

            // return of(true);
            return this.rc.exportTable(cacheKey, tableId).pipe(
                switchMap(result => {
                    const link = document.createElement("a"); //create 'a' element
                    link.setAttribute("href", result.spreadsheet); //replace "file" with link to file you want to download
                    link.setAttribute("download", result.spreadsheet);// replace "file" here too
                    link.click();
                    return of(true);
                })
            );
        })
    ), { dispatch: false });

}